import { SVGProps } from 'react';

import palette from '../../../theme/palette';
import { styleConfigs } from '../../resources/styleConfigs';

const BellNotificationIcon = ({
  width = styleConfigs.dimensions.width20,
  height = styleConfigs.dimensions.height21,
  stroke = palette.light.icons.ebonyClay,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.33325 18.25C8.55066 18.9906 9.23016 19.4993 10.002 19.4993C10.7738 19.4993 11.4533 18.9906 11.6708 18.25"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 2.625V0.75" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.625C13.4518 2.625 16.25 5.42322 16.25 8.875C16.25 14.7467 17.5 15.75 17.5 15.75H2.5C2.5 15.75 3.75 14.1533 3.75 8.875C3.75 5.42322 6.54822 2.625 10 2.625Z"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BellNotificationIcon;
